<template>
  <core-main class="px-8 py-12">
    <template #toolbar-title>
      {{ $t('form.rfq.name') }}
    </template>

    <template #toolbar-icons>
      <v-btn slot="activator" icon @click="setView">
        <v-icon>{{ isCardView ? 'mdi-format-list-bulleted' : 'mdi-view-grid' }}</v-icon>
      </v-btn>

      <v-btn slot="activator" icon @click="toggleFilter">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </template>

    <template #extension>
      <v-row>
        <v-col v-if="!isCardView" cols="auto">
          <v-select
            v-model="groupBy"
            :items="groupingOptions"
            color="grey darken-3"
            background-color="grey darken-3"
            hide-details
            solo
            dense
          />
        </v-col>

        <v-col>
          <core-search-bar v-model="search" />
        </v-col>
      </v-row>
    </template>

    <core-no-content v-if="!isFindPending && _.isEmpty(allRfqs)" />

    <v-row>
      <v-col>
        <template v-if="isCardView">
          <v-row v-if="isFindPending">
            <v-col
              v-for="n in 6"
              :key="n"
              cols="12"
              lg="6"
            >
              <core-rfq-card-skeleton />
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col
              v-for="(rfq, i) of allRfqs"
              :key="i"
              cols="12"
              lg="6"
            >
              <core-rfq-card
                :rfq="rfq"
                :quote-actions="quoteActions"
                @viewParts:clicked="fetchParts(rfq._id)"
                @action:clicked="handleQuoteAction(rfq, $event)"
              />
            </v-col>
          </v-row>
        </template>

        <template v-else>
          <v-row>
            <v-col>
              <core-main-table
                v-if="groupBy === 'Group by quote'"
                ref="groupByQuote"
                :headers="groupedByQuoteHeaders"
                :items="allRfqs"
                :search.sync="search"
                :loading="isFindPending"
                rights-group="rfq"
                show-expand
                @click-expand="!$event.isExpanded && fetchParts($event.item._id)"
                @menu-click="(action, tableItem) => {
                  handleQuoteAction(tableItem.item, action.type);
                }"
              >
                <template #expanded-item="props">
                  <core-rfq-parts-table :rfq-id="props.item._id" />
                </template>

                <template v-slot:item._id="{ item }">
                  <span>{{ item._id }}</span>
                  <v-chip class="ml-2 px-2" small>
                    <span class="caption">{{ item.NumLines }} parts</span>
                  </v-chip>
                </template>

                <!-- TODO once implemented from CSI -->
                <template v-slot:item.pricing="{ item }">
                  <span>{{ formatCurrency(item.pricing, true) }}</span>
                </template>
              </core-main-table>

              <core-main-table
                v-else-if="groupBy === 'Group by none'"
                :headers="groupedByNoneHeaders"
                :items="allParts"
                :search.sync="search"
                rights-group="rfq"
              >
                <!--                <template v-slot:expanded-item="props">-->
                <!--                  <core-main-table-->
                <!--                    :headers="partsTableHeaders"-->
                <!--                    :items="props.item.parts"-->
                <!--                    class="my-4 ml-4"-->
                <!--                    hide-default-footer-->
                <!--                    rights-group="rfq"-->
                <!--                  >-->
                <!--                    <template v-slot:item.clientPartNo="{ item }">-->
                <!--                      <div class="d-flex">-->
                <!--                        <v-img-->
                <!--                          :src="getPartName"-->
                <!--                          max-width="20px"-->
                <!--                          max-height="20px"-->
                <!--                          class="mr-2"-->
                <!--                        />-->
                <!--                        <span>{{ item.clientPartNo }}</span>-->
                <!--                      </div>-->
                <!--                    </template>-->

                <template #item.PriceMOQ="{ item }">
                  <core-table-unit-pricing :item="item" />
                </template>

                <template #item.ReqQty="{ item }">
                  {{ parseInt(item.ReqQty) }}
                </template>


                <!--                  </core-main-table>-->
                <!--                </template>-->

                <template v-slot:item.expires="{ item }">
                  <span>{{ formatDate(item.expires) }}</span>
                </template>

                <template v-slot:item.pricing="{ item }">
                  <span>{{ formatCurrency(item.pricing, true) }}</span>
                </template>
              </core-main-table>
            </v-col>
          </v-row>
        </template>
      </v-col>

      <v-col
        v-if="areFiltersActive"
        cols="2"
        class="pt-0 fill-height"
        style="border-left: 1px solid rgba(0,0,0,.12);"
      >
        <div class="d-flex">
          <core-filter-main @filter:close="areFiltersActive = false">
            <core-filter-checkbox-group
              v-model="filterData.status.value"
              :options="filterData.status.options"
              :section="filterData.status.section"
            />
            <v-divider class="mt-6 ml-4" />

            <core-filter-radio-group
              v-model="filterData.orderBy.value"
              :options="filterData.orderBy.options"
              :section="filterData.orderBy.section"
            />
            <v-divider class="ml-4" />

            <core-filter-range-slider
              v-model="filterData.pricing.value"
              :options="filterData.pricing.options"
              :section="filterData.pricing.section"
            />
            <v-divider class="ml-4" />

            <core-filter-switch-group
              v-model="filterData.ownership.value"
              :options="filterData.ownership.options"
              :section="filterData.ownership.section"
            />
          </core-filter-main>
        </div>
      </v-col>
    </v-row>

    <v-navigation-drawer
      v-model="isRfqViewerActive"
      style="margin-top: 64px; width: calc(100% - 200px); max-width: 1400px;"
      fixed
      clipped
      right
      temporary
    >
      <div style="position: absolute; z-index: 99; width: 100%;">
        <div class="d-flex justify-end mr-2 mt-2" style="position: sticky; width: 100%;">
          <v-btn icon @click="toggleRfqViewer(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <div
        v-if="isPdfLoading"
        style="display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 100%;"
      >
        <v-progress-circular
          indeterminate
        />
      </div>

      <template v-if="quotePdfPageCount">
        <pdf
          v-for="i in quotePdfPageCount"
          :key="i"
          :src="quotePdfUrl"
          :page="i"
          @loaded="isPdfLoading = false"
        />
      </template>
      <!--        style="display: inline-block; width: 25%"-->

      <!--      <pdf-->
      <!--        v-if="isRfqViewerActive"-->
      <!--        :src="quotePdfUrl"-->
      <!--        @loaded="isPdfLoading = false;"-->
      <!--      />-->
    </v-navigation-drawer>

    <v-dialog
      v-model="emailDialog.isActive"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Emailing Quote
        </v-card-title>
        <v-container v-if="!emailDialog.text" class="d-flex justify-center align-center">
          <v-progress-circular indeterminate />
        </v-container>
        <v-card-text v-else>
          {{ emailDialog.text }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="emailDialog.isActive = false;"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </core-main>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import pdf from 'vue-pdf';
import { models } from 'feathers-vuex';
import CurrencyFormatterMixin from '../../mixins/currencyFormatter';
import FilterableTextMixin from '../mixins/filterableText';

const { Rfq, Part } = models.api;

const loadingTask = undefined;

export default {

  mixins: [
    CurrencyFormatterMixin,
    FilterableTextMixin,
  ],

  components: {
    pdf,
  },

  data() {
    return {
      isPdfLoading: false,

      quotePdfUrl: loadingTask,
      quotePdfPageCount: undefined,

      isRfqViewerActive: false,

      emailDialog: {
        isActive: false,
        text: '',
      },

      quoteViewerQuote: {},

      groupingOptions: [
        'Group by none',
        'Group by quote',
      ],

      groupBy: 'Group by quote',

      search: '',

      areFiltersActive: false,

      isCardView: true,

      filterData: {
        status: {
          section: 'Status',
          options: [
            'In Progress',
            'Shipped',
            'Delivered',
            'Deleting',
          ],
          value: [
          ],
        },
        orderBy: {
          section: 'Order By',
          options: [
            'Ordered by',
            'Delivery Date',
            'Status',
            'Number of Parts',
          ],
          value: '',
        },
        pricing: {
          section: 'Pricing',
          min: 0,
          max: 999999,
          value: [
            0, 0,
          ],
        },
        ownership: {
          section: 'Ownership',
          options: [
            'Submitted by Me',
          ],
          value: [
          ],
        },
      },
    };
  },

  computed: {
    ...mapState('rfqs', ['isFindPending']),

    ...mapState('auth', {
      accessToken: 'accessToken',
    }),

    allRfqs() {
      return Rfq.findInStore({ query: {} }).data;
    },

    allParts() {
      return Part.findInStore({ query: {} }).data;
    },

    quoteActions() {
      return [
        { type: 'view', label: 'View Quote' },
        { type: 'email', label: 'Email Quote' },
        { type: 'delete', label: 'Delete Quote' },
      ];
    },

    quoteActions() {
      return [
        { type: 'view', label: 'View Quote' },
        { type: 'email', label: 'Email Quote' },
        { type: 'delete', label: 'Delete Quote' },
      ];
    },

    getDisplayIcon() {
      return this.isCardView ? 'mdi-format-list-bulleted' : 'mdi-view-grid';
    },

    groupedByQuoteHeaders() {
      return [
        {
          text: '',
          value: 'data-table-expand',
        },
        {
          text: 'RFQ reference #',
          value: '_id',
        },
        {
          text: 'Submitted by',
          value: 'CreatedByUserName',
        },
        {
          text: 'Pricing',
          value: 'pricing',
        },
        {
          text: 'Status',
          value: 'Status',
        },
        {
          text: 'Expires on',
          value: 'ExpiryDate',
        },
        {
          text: '',
          value: 'data-table-menu',
          items: this.quoteActions,
        },
      ];
    },

    groupedByNoneHeaders() {
      return [
        {
          text: 'RFQ reference #',
          value: 'EstimateID',
        },
        {
          text: 'Client part #',
          value: 'CustItemName',
        },
        {
          text: 'Requested Qty',
          value: 'ReqQty',
        },
        {
          text: 'Submitted by',
          value: 'CreatedByUserName',
        },
        {
          text: 'Description',
          value: 'Description',
          sortable: false,
        },
        {
          text: 'Material',
          value: 'MaterialSeriesStr',
          sortable: false,
        },
        {
          text: 'Thickness',
          value: 'MaterialThicknessStr',
          sortable: false,
        },
        {
          text: 'Finish',
          value: 'MaterialFinishStr',
          sortable: false,
        },
        {
          text: 'Price/MOQ',
          value: 'PriceMOQ',
          sortable: false,
        },
        {
          text: '',
          value: 'data-table-menu',
          items: [
            { label: 'Option 1' },
            { label: 'Option 2' },
          ],
        },
      ];
    },

    // Computed property means this Math.random will only evaluate once
    getPartName() {
      return `/img/placeholder_item_${Math.floor(Math.random() * 3) + 1}.png`;
    },
  },

  mounted() {
    Rfq.find({ query: {} });
    Part.find({ query: {} });
  },

  methods: {
    ...mapActions('rfqs', { removeRfq: 'remove' }),
    ...mapActions('parts', { fetchPartsByRFQID: 'find' }),

    getQuotePdfUrl() {
      const host = process.env.VUE_APP_API_URL || 'http://localhost:3031/';
      const url = `${host}quotePdf/${this.accessToken}/${this.quoteViewerQuote._id}`;
      return url;
    },

    async handleQuoteAction(quote, actionType) {
      switch (actionType) {
        case 'view':
          this.toggleRfqViewer(quote);
          break;
        case 'email':
          try {
            this.emailDialog.text = '';
            this.emailDialog.isActive = true;
            await quote.patch({ shouldEmailCustomer: true });
            this.emailDialog.text = 'You should receive an email shortly... If it\'s not in your inbox, check your junk mail.';
          } catch (e) {
            this.emailDialog.text = 'Something went wrong while trying to send your quote via email. Please try again...';
          }
          break;
        case 'delete':
          this.removeRfq(quote._id);
          break;
        default:
      }
    },

    async toggleRfqViewer(quote) {
      this.isRfqViewerActive = !!quote;
      this.quoteViewerQuote = quote;
      if (this.isRfqViewerActive) {
        this.isPdfLoading = true;
        this.quotePdfUrl = pdf.createLoadingTask(this.getQuotePdfUrl());
        this.quotePdfUrl.promise.then((quotePdf) => {
          this.quotePdfPageCount = quotePdf.numPages;
        });
        // await this.fetchParts(this.quoteViewerQuote._id);
      }
    },

    fetchParts(rfqID) {
      Part.find({
        query: {
          EstimateID: rfqID || 'ALL',
        },
      });
    },

    setView() {
      this.isCardView = !this.isCardView;
    },

    toggleFilter() {
      this.areFiltersActive = !this.areFiltersActive;
    },

    formatDate(date) {
      if (!moment(date).isValid()) {
        return '';
      }
      return moment(date).format('YYYY-MM-DD');
    },
  },
};
</script>
